import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header search_type" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("선물하기")
const _hoisted_3 = {
  id: "content",
  class: "content main_search"
}
const _hoisted_4 = { class: "search_area" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", {
  for: "prod_search",
  class: "blind"
}, "검색", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "ico_del" }, "지우기", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "btn_txt" }, "취소", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")
  const _component_recent_search_word_component = _resolveComponent("recent-search-word-component")
  const _component_no_search_result_component = _resolveComponent("no-search-result-component")
  const _component_search_result_component = _resolveComponent("search-result-component")
  const _component_to_top_component = _resolveComponent("to-top-component")

  return (_openBlock(), _createBlock("div", {
    id: "wrap",
    class: ["wrap", {app_view: _ctx.isApp}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_header_component, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("span", {
          class: ["inp_bx", {'is_focus': _ctx.isTypingMode}]
        }, [
          _hoisted_5,
          _createVNode("input", {
            ref: "searchInputArea",
            value: _ctx.searchWord,
            onFocusin: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTypingMode(true))),
            onFocusout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTypingMode(false))),
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.inputSearchWord && _ctx.inputSearchWord(...args))),
            onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.getSearchResult && _ctx.getSearchResult(...args)), ["enter"])),
            type: "search",
            id: "prod_search",
            class: "inp",
            placeholder: "상품명을 검색하세요"
          }, null, 40, ["value"]),
          _withDirectives(_createVNode("button", {
            onMousedown: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.eraseSearchWord && _ctx.eraseSearchWord(...args)), ["prevent"])),
            type: "button",
            class: ["btn_del", {'with_cancel': _ctx.isTypingMode}]
          }, [
            _hoisted_6
          ], 34), [
            [_vShow, _ctx.hasSearchWord]
          ]),
          _withDirectives(_createVNode("button", {
            onMousedown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.moveToPreviousPage && _ctx.moveToPreviousPage(...args))),
            type: "button",
            class: "btn_srch_cancel"
          }, [
            _hoisted_7
          ], 544), [
            [_vShow, _ctx.isTypingMode]
          ])
        ], 2)
      ]),
      (_ctx.hasRecentSearchWordList)
        ? _withDirectives((_openBlock(), _createBlock(_component_recent_search_word_component, {
            key: 0,
            recentSearchWordList: _ctx.recentSearchWordList,
            onClickRecentSearchWord: _ctx.clickRecentSearchWord,
            onDeleteRecentSearchWord: _ctx.deleteRecentSearchWord
          }, null, 8, ["recentSearchWordList", "onClickRecentSearchWord", "onDeleteRecentSearchWord"])), [
            [_vShow, _ctx.isTypingMode]
          ])
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_no_search_result_component, null, null, 512), [
        [_vShow, !_ctx.isTypingMode && !_ctx.isLoading && !_ctx.hasSearchResult]
      ]),
      _withDirectives(_createVNode(_component_search_result_component, {
        totalCount: _ctx.totalCount,
        products: _ctx.products,
        onLoadNewItem: _ctx.getSearchResult
      }, null, 8, ["totalCount", "products", "onLoadNewItem"]), [
        [_vShow, !_ctx.isTypingMode && !_ctx.isLoading && _ctx.hasSearchResult]
      ])
    ]),
    _createVNode(_component_to_top_component)
  ], 2))
}